import { render, staticRenderFns } from "./MeasurementCard.vue?vue&type=template&id=e538afcc&scoped=true&"
import script from "./MeasurementCard.vue?vue&type=script&lang=js&"
export * from "./MeasurementCard.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementCard.vue?vue&type=style&index=0&id=e538afcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e538afcc",
  null
  
)

export default component.exports